var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var _section;
import { _ as __vitePreload } from "./preload-helper-BbOs9S9B.js";
import { E as EmblaCarousel } from "./embla-carousel.esm-3bCdUmQG.js";
import { F as Fade } from "./embla-carousel-fade.esm-CqGaA1Zm.js";
import { a as addPrevNextBtnsClickHandlersSSR, b as addDotsBtnsAndClickHandlersSSR, c as addInstagramDotBtnsAndClickHandlers, h as addNumberPagination, i as addThumbButtonClickHandlers, j as addToggleThumbButtonsActive } from "./embla-extension-OubijMX1.js";
import { P as PhotoSwipeLightbox } from "./photoswipe-lightbox.esm-Dtup_PBa.js";
import { C as CustomEvents } from "./events-DeC3n8dp.js";
import { d as debounce, c as isDesktop, i as isMobile, a as lazyReveal, l as lazyInit } from "./utilities-2Suih3Nm.js";
function stopAllMediaOnSlide(slide) {
  if (!slide) return;
  const mediaSelectors = ["deferred-media", "product-model", "custom-video"];
  mediaSelectors.forEach((selector) => {
    slide.querySelectorAll(selector).forEach((mediaEl) => {
      if (typeof mediaEl.pauseMedia === "function") {
        mediaEl.pauseMedia();
      }
    });
  });
}
class ProductMediaGallery extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _section, null);
    __publicField(this, "updateProductMediaGallery", (event) => {
      const newProdMediaGallery = event.detail.data.html.querySelector("product-media-gallery");
      if (!newProdMediaGallery) return;
      this.replaceWith(newProdMediaGallery);
      lazyReveal(newProdMediaGallery);
    });
    this.mainSliderEl = null;
    this.thumbnailsSliderEl = null;
    this.enableImageZoomDesktop = false;
    this.enableImageZoomMobile = false;
    this.lightbox = null;
    this._debouncedResize = debounce(this.handleResize.bind(this), 500);
  }
  connectedCallback() {
    this.mainSliderEl = this.querySelector("#ProductMediaMainSlider");
    this.thumbnailsSliderEl = this.querySelector("#ProductMediaThumbnailsSlider");
    this.enableImageZoomDesktop = this.dataset.enableImageZoomDesktop === "true";
    this.enableImageZoomMobile = this.dataset.enableImageZoomMobile === "true";
    if (this.shouldHaveLightbox) {
      this.initLightbox();
    }
    __privateSet(this, _section, this.closest("quick-view-dialog") || this.closest(".shopify-section"));
    if (__privateGet(this, _section)) {
      __privateGet(this, _section).addEventListener(CustomEvents.variantPickerUpdate, this.updateProductMediaGallery);
    }
    this._onZoomClick = this._handleZoomClick.bind(this);
    this.addEventListener("click", this._onZoomClick);
    window.addEventListener("resize", this._debouncedResize);
  }
  disconnectedCallback() {
    if (__privateGet(this, _section)) {
      __privateGet(this, _section).removeEventListener(CustomEvents.variantPickerUpdate, this.updateProductMediaGallery);
      __privateSet(this, _section, null);
    }
    this.removeEventListener("click", this._onZoomClick);
    window.removeEventListener("resize", this._debouncedResize);
    this.destroyLightbox();
  }
  get shouldHaveLightbox() {
    return this.enableImageZoomDesktop && isDesktop() || this.enableImageZoomMobile && isMobile();
  }
  // ========== Lightbox ==========
  initLightbox() {
    if (this.lightbox) return;
    const leftArrowSVGString = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6668 8.00016H3.3335M3.3335 8.00016L8.00016 12.6668M3.3335 8.00016L8.00016 3.3335" stroke="currentColor" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const closeSVGString = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-close-x"><path class="icon-close-x-1" d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path class="icon-close-x-2" d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const zoomSVGString = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="pswp__zoom-icn-bar-v" d="M21 21L16.65 16.65M11 8V14M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path class="pswp__zoom-icn-bar-h" d="M21 21L16.65 16.65 M8 11H14 M19 11C19 15.4183 15.4183 19 11 19 C6.58172 19 3 15.4183 3 11 C3 6.58172 6.58172 3 11 3 C15.4183 3 19 6.58172 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const lightbox = new PhotoSwipeLightbox({
      pswpModule: () => __vitePreload(() => import("./photoswipe.esm-D5Lhsnyf.js"), true ? [] : void 0, import.meta.url),
      bgOpacity: 1,
      initialZoomLevel: "fit",
      secondaryZoomLevel: "fill",
      allowPanToNext: false,
      allowMouseDrag: true,
      wheelToZoom: false,
      returnFocus: true,
      zoom: false,
      arrowPrevSVG: leftArrowSVGString,
      arrowNextSVG: leftArrowSVGString,
      closeSVG: closeSVGString,
      zoomSVG: zoomSVGString
    });
    lightbox.addFilter("thumbEl", (_thumbEl, data) => data["thumbnailElement"]);
    lightbox.on("contentLoad", (event) => {
      const { content } = event;
      if (content.type === "video" || content.type === "external_video" || content.type === "model") {
        event.preventDefault();
        content.element = document.createElement("div");
        content.element.className = "pswp__video-container";
        content.element.appendChild(content.data.thumbnailElement.cloneNode(true));
        content.element.appendChild(content.data.domElement.cloneNode(true));
      }
    });
    lightbox.on("change", () => {
      var _a, _b, _c, _d;
      const pswp = lightbox.pswp;
      const mainSlider = this.querySelector("#ProductMediaMainSlider");
      if (mainSlider == null ? void 0 : mainSlider.emblaApi) {
        mainSlider.emblaApi.scrollTo(pswp.currIndex, true);
      }
      const currData = (_a = pswp.currSlide) == null ? void 0 : _a.data;
      const deferredEl = currData == null ? void 0 : currData.domElement;
      if (((_b = deferredEl == null ? void 0 : deferredEl.tagName) == null ? void 0 : _b.toLowerCase()) === "deferred-media" && deferredEl.hasAttribute("autoplay")) {
        const clonedDeferred = (_c = pswp.currSlide.content.element) == null ? void 0 : _c.querySelector("deferred-media");
        (_d = clonedDeferred == null ? void 0 : clonedDeferred.showDeferredMedia) == null ? void 0 : _d.call(clonedDeferred);
      }
    });
    lightbox.on("pointerDown", (e) => {
      const productModel = e.originalEvent.target.closest("product-model");
      if (productModel && productModel.querySelector(".shopify-model-viewer-ui__button[hidden]")) {
        e.preventDefault();
      }
    });
    lightbox.on("uiRegister", function() {
      lightbox.pswp.ui.registerElement({
        name: "bulletsIndicator",
        className: "pswp__bullets-indicator",
        title: "Pagination Bullets",
        appendTo: "wrapper",
        onInit: (el, pswp) => {
          const bullets = [];
          let bullet;
          let prevIndex = -1;
          for (let i = 0; i < pswp.getNumItems(); i++) {
            bullet = document.createElement("div");
            bullet.className = "pswp__bullet";
            bullet.onclick = (e) => {
              pswp.goTo(bullets.indexOf(e.target));
            };
            el.appendChild(bullet);
            bullets.push(bullet);
          }
          pswp.on("change", () => {
            if (prevIndex >= 0) {
              bullets[prevIndex].classList.remove("pswp__bullet--active");
            }
            bullets[pswp.currIndex].classList.add("pswp__bullet--active");
            prevIndex = pswp.currIndex;
          });
        }
      });
    });
    lightbox.init();
    this.lightbox = lightbox;
  }
  destroyLightbox() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  }
  /**
   * Build a data source array from the DOM and open PhotoSwipe at the given slide index.
   * Supports image, video, external_video, and model media types.
   * @param {number} index - The slide index (0-based) to open the lightbox at.
   */
  openZoomMedia(index = 0) {
    if (!this.lightbox) return;
    const mainSlider = this.querySelector("#ProductMediaMainSlider");
    if (!mainSlider) return;
    const mediaItems = mainSlider.querySelectorAll(".media-item[data-media-type]");
    const dataSource = [];
    mediaItems.forEach((media) => {
      const image = media.querySelector("img");
      if (!image) return;
      const mediaType = media.dataset.mediaType;
      if (mediaType === "image") {
        dataSource.push({
          thumbnailElement: image,
          src: image.dataset.maxResolution || image.currentSrc || image.src,
          srcset: image.srcset,
          msrc: image.currentSrc || image.src,
          width: parseInt(image.getAttribute("width"), 10) || image.naturalWidth,
          height: parseInt(image.getAttribute("height"), 10) || image.naturalHeight,
          alt: image.alt,
          thumbCropped: true
        });
      } else if (mediaType === "video" || mediaType === "external_video" || mediaType === "model") {
        const deferredEl = media.querySelector("deferred-media, product-model");
        dataSource.push({
          thumbnailElement: image,
          domElement: deferredEl,
          type: mediaType,
          src: image.currentSrc || image.src,
          msrc: image.currentSrc || image.src,
          width: parseInt(image.getAttribute("width"), 10) || 800,
          height: parseInt(image.getAttribute("height"), 10) || 800,
          alt: image.alt,
          thumbCropped: true
        });
      }
    });
    if (dataSource.length === 0) return;
    this.lightbox.loadAndOpen(index, dataSource);
  }
  // ========== Zoom Button Click Delegation ==========
  _handleZoomClick(event) {
    const zoomBtn = event.target.closest(".zoom-button-wrap");
    if (!zoomBtn) return;
    event.preventDefault();
    event.stopPropagation();
    const slide = zoomBtn.closest(".embla__slide");
    if (!slide) return;
    const mainSlider = this.querySelector("#ProductMediaMainSlider");
    if (!mainSlider) return;
    const slides = [...mainSlider.querySelectorAll(".embla__slide")];
    const slideIndex = slides.indexOf(slide);
    if (slideIndex >= 0) {
      this.openZoomMedia(slideIndex);
    }
  }
  handleResize() {
    if (this.shouldHaveLightbox) {
      this.initLightbox();
    } else {
      this.destroyLightbox();
    }
  }
}
_section = new WeakMap();
if (!customElements.get("product-media-gallery")) {
  customElements.define("product-media-gallery", ProductMediaGallery);
}
class MediaSlider extends HTMLElement {
  constructor() {
    super();
    this.emblaApi = null;
    this.cleanupFunctions = [];
    this.currentDeviceType = null;
    this._isFirstInit = true;
    this.nodes = {
      embla: null,
      viewport: null,
      prevBtn: null,
      nextBtn: null,
      dots: null
    };
    this.config = {
      showNavigation: false,
      showDots: false,
      showNumberPagination: false,
      options: {},
      fade: false
    };
    this.thumbs = {
      emblaApi: null,
      nodes: {
        embla: null,
        viewport: null,
        container: null
      },
      config: {
        showNavigation: false,
        options: {}
      }
    };
    this.handleResize = debounce(() => this.onResize(), 500);
  }
  connectedCallback() {
    this.cacheNodes();
    this.parseConfig();
    this.currentDeviceType = isMobile() ? "mobile" : "desktop";
    if (Shopify.designMode) {
      this.init();
    } else {
      lazyInit(this, () => this.init());
    }
    window.addEventListener("resize", this.handleResize);
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    this.destroy();
  }
  // ========== DOM & Configuration ==========
  cacheNodes() {
    this.nodes.embla = this.querySelector(".embla");
    if (!this.nodes.embla) return;
    this.nodes.viewport = this.nodes.embla.querySelector(".embla__viewport");
    this.nodes.prevBtn = this.nodes.embla.querySelector(".embla__snip-button--prev");
    this.nodes.nextBtn = this.nodes.embla.querySelector(".embla__snip-button--next");
    this.nodes.dots = this.nodes.embla.querySelector(".embla__snip-dots");
  }
  parseConfig() {
    this.config.showNavigation = this.dataset.showNavigation === "true";
    this.config.showDots = this.dataset.showDots === "true";
    this.config.showNumberPagination = this.dataset.showNumberPagination === "true";
    this.config.options = this.parseJSON(this.dataset.options, {});
    this.config.options.watchDrag = (_emblaApi, evt) => {
      const productModel = evt.target.closest("product-model");
      if (productModel && productModel.querySelector(".shopify-model-viewer-ui__button[hidden]")) {
        return false;
      }
      return true;
    };
    this.config.fade = this.dataset.fade === "true";
  }
  parseJSON(jsonString, fallback) {
    if (!jsonString || !jsonString.trim()) return fallback;
    try {
      const parsed = JSON.parse(jsonString.replace(/,\s*([}\]])/g, "$1"));
      if (typeof parsed === "object" && !Array.isArray(parsed)) {
        return parsed;
      }
      return fallback;
    } catch (error) {
      return fallback;
    }
  }
  // ========== Initialization ==========
  init() {
    if (this.emblaApi) {
      this.destroy();
    }
    this.initEmbla();
    this.cacheThumbsNodes();
    if (this.thumbs.nodes.embla) {
      this.parseThumbsConfig();
      this.initThumbs();
    }
  }
  initEmbla() {
    if (!this.nodes.viewport) return;
    const plugins = [];
    if (this.config.fade) {
      plugins.push(Fade());
    }
    try {
      this.emblaApi = EmblaCarousel(this.nodes.viewport, this.config.options, plugins);
      this.setupFeatures();
      this._isFirstInit = false;
    } catch (error) {
    }
  }
  setupFeatures() {
    if (this.config.showNavigation) this.enableNavigation();
    if (this.config.showDots) this.enableDots();
    if (this.config.showNumberPagination) this.enableNumberPagination();
    this.enableDeferredMediaAutoplay();
  }
  // ========== Main Slider Features ==========
  enableNavigation() {
    const { prevBtn, nextBtn } = this.nodes;
    if (!prevBtn || !nextBtn || !this.emblaApi) return;
    const cleanup = addPrevNextBtnsClickHandlersSSR(this.emblaApi, prevBtn, nextBtn);
    this.registerCleanup(cleanup);
  }
  enableDots() {
    const { dots } = this.nodes;
    if (!dots || !this.emblaApi) return;
    const dotsInner = dots.querySelector(".embla__dots-inner") || dots;
    const ssrDotCount = dotsInner.querySelectorAll(".embla__dot").length;
    const snapCount = this.emblaApi.scrollSnapList().length;
    let cleanup;
    if (this._isFirstInit && ssrDotCount === snapCount) {
      cleanup = addDotsBtnsAndClickHandlersSSR(this.emblaApi, dots);
    } else {
      cleanup = addInstagramDotBtnsAndClickHandlers(this.emblaApi, dotsInner);
    }
    this.registerCleanup(cleanup);
  }
  enableNumberPagination() {
    const paginationContainer = this.querySelector(".embla__number-pagination");
    if (!paginationContainer || !this.emblaApi) return;
    const cleanup = addNumberPagination(this.emblaApi, paginationContainer);
    this.registerCleanup(cleanup);
  }
  enableDeferredMediaAutoplay() {
    if (!this.emblaApi) return;
    let prevSlideIndex = null;
    const onSelect = () => {
      const slideNodes = this.emblaApi.slideNodes();
      const selectedSlide = slideNodes[this.emblaApi.selectedScrollSnap()];
      if (prevSlideIndex !== null && prevSlideIndex !== this.emblaApi.selectedScrollSnap()) {
        const prevSlide = slideNodes[prevSlideIndex];
        stopAllMediaOnSlide(prevSlide);
      }
      prevSlideIndex = this.emblaApi.selectedScrollSnap();
      if (selectedSlide) {
        const deferredMedia = selectedSlide.querySelector("deferred-media");
        if (deferredMedia && deferredMedia.hasAttribute("autoplay")) {
          if (typeof deferredMedia.showDeferredMedia === "function") {
            deferredMedia.showDeferredMedia();
          }
          if (deferredMedia.hasAttribute("data-media-loaded") && deferredMedia.getAttribute("data-media-loaded") === "true") {
            deferredMedia.playMedia();
          }
        }
      }
    };
    this.emblaApi.on("select", onSelect);
    onSelect();
    const cleanup = () => {
      this.emblaApi.off("select", onSelect);
    };
    this.registerCleanup(cleanup);
  }
  // ========== Thumbnail Slider ==========
  cacheThumbsNodes() {
    this.thumbs.nodes.embla = this.querySelector(".embla-thumbs");
    if (!this.thumbs.nodes.embla) return;
    this.thumbs.nodes.viewport = this.thumbs.nodes.embla.querySelector(".embla-thumbs__viewport");
    if (!this.thumbs.nodes.viewport) return;
    this.thumbs.nodes.container = this.thumbs.nodes.viewport.querySelector(".embla-thumbs__container");
  }
  parseThumbsConfig() {
    this.thumbs.config.options = this.parseJSON(this.thumbs.nodes.embla.dataset.options, {});
  }
  initThumbs() {
    if (this.thumbs.emblaApi) {
      this.destroyThumbs();
    }
    try {
      this.thumbs.emblaApi = EmblaCarousel(
        this.thumbs.nodes.viewport,
        this.thumbs.config.options
      );
      requestAnimationFrame(() => {
        this.thumbsSetupFeatures();
      });
    } catch (error) {
    }
  }
  thumbsSetupFeatures() {
    const clickCleanup = addThumbButtonClickHandlers(this.emblaApi, this.thumbs.emblaApi);
    this.registerCleanup(clickCleanup);
    const activeCleanup = addToggleThumbButtonsActive(this.emblaApi, this.thumbs.emblaApi);
    this.registerCleanup(activeCleanup);
  }
  // ========== Resize ==========
  onResize() {
    const newDeviceType = isMobile() ? "mobile" : "desktop";
    if (this.currentDeviceType !== newDeviceType) {
      this.currentDeviceType = newDeviceType;
      this.init();
    }
  }
  // ========== Cleanup ==========
  registerCleanup(fn) {
    if (fn && typeof fn === "function") this.cleanupFunctions.push(fn);
  }
  destroyThumbs() {
    if (this.thumbs.emblaApi) {
      try {
        this.thumbs.emblaApi.destroy();
      } catch {
      }
      this.thumbs.emblaApi = null;
    }
  }
  destroy() {
    this.cleanupFunctions.forEach((fn) => {
      try {
        fn();
      } catch {
      }
    });
    this.cleanupFunctions = [];
    if (this.emblaApi) {
      try {
        this.emblaApi.destroy();
      } catch {
      }
      this.emblaApi = null;
    }
    this.destroyThumbs();
  }
}
if (!customElements.get("media-slider")) {
  customElements.define("media-slider", MediaSlider);
}
